import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class StatisticsService {
  baseUrl = environment.baseApiURL;
  userId!: string;
  private isTrainingTemplate: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getStatistics(): Observable<any> {
    const currentFileId = localStorage.getItem('fileId');
    return this.http.get<any>(`${this.baseUrl}statistics/${currentFileId}?page=1&nbItems=5`);
  }

  getOutputSummary(page: number){
    const currentFileId = localStorage.getItem('fileId');
    return this.http.get<any>(`${this.baseUrl}statistics/${currentFileId}/output/summary?page=${page}&nbItems=5`);
  }

  getOutcomeSummary(page: number){
    const currentFileId = localStorage.getItem('fileId');
    return this.http.get<any>(`${this.baseUrl}statistics/${currentFileId}/outcome/summary?page=${page}&nbItems=5`);
  }


  setFileId(fileId:string){
    localStorage.removeItem('fileId');
    localStorage.setItem('fileId',fileId);
  }

  setUserId(userId:string){
    this.userId = userId;
  }

  getUserId(){
    return this.userId;
  }

  setIsTraining(value:boolean){
    this.isTrainingTemplate.next(value);
  }

  getIsTraining(){
    return this.isTrainingTemplate.asObservable();
  }

}
